// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application'
import { registerControllers } from 'stimulus-vite-helpers'
import { setBasePath } from '@shoelace-style/shoelace/dist/utilities/base-path.js'
setBasePath('/shoelace-assets')

import '@shoelace-style/shoelace/dist/components/avatar/avatar.js'
import '@shoelace-style/shoelace/dist/components/input/input.js'
import '@shoelace-style/shoelace/dist/components/tooltip/tooltip.js'
import '@shoelace-style/shoelace/dist/components/dropdown/dropdown.js'
import '@shoelace-style/shoelace/dist/components/checkbox/checkbox.js'
import '@shoelace-style/shoelace/dist/components/dialog/dialog.js'
import '@shoelace-style/shoelace/dist/components/drawer/drawer.js'
import '@shoelace-style/shoelace/dist/components/breadcrumb/breadcrumb.js'
import '@shoelace-style/shoelace/dist/components/breadcrumb-item/breadcrumb-item.js'
import '@shoelace-style/shoelace/dist/components/tab/tab.js'
import '@shoelace-style/shoelace/dist/components/tab-panel/tab-panel.js'
import '@shoelace-style/shoelace/dist/components/tab-group/tab-group.js'
import '@shoelace-style/shoelace/dist/components/format-number/format-number.js'
import '@shoelace-style/shoelace/dist/components/alert/alert.js';
import '@shoelace-style/shoelace/dist/components/skeleton/skeleton.js'

// Import and register all TailwindCSS Components
// import {
//   Alert,
//   Autosave,
//   Dropdown,
//   Modal,
//   Tabs,
//   Popover,
//   Toggle,
//   Slideover,
// } from "tailwindcss-stimulus-components";
// application.register('alert', Alert)
// application.register('autosave', Autosave)
// application.register('dropdown', Dropdown)
// application.register('modal', Modal)
// application.register('tabs', Tabs)
// application.register('popover', Popover)
// application.register("toggle", Toggle);
// application.register('slideover', Slideover)

import Timeago from 'stimulus-timeago'
application.register('timeago', Timeago)

import debounced from 'debounced'
debounced.initialize()

import ScrollTo from 'stimulus-scroll-to'
application.register('scroll-to', ScrollTo)

import ScrollReveal from '@stimulus-components/scroll-reveal'
application.register('scroll-reveal', ScrollReveal)

const controllers = import.meta.globEager('./**/*_controller.js')
registerControllers(application, controllers)

const vcControllers = import.meta.globEager(
  '../../components/aon/**/*_controller.js'
)
registerControllers(application, vcControllers)
